// Dialog paper — nested selector wins over MUI class specificity
export const dialog = {
    '& .MuiDialog-paper': {
        background: 'rgb(6, 6, 56)',
        border: '1px solid rgba(187, 188, 188, 0.18)',
        borderRadius: '24px',
        boxShadow: '0px 48px 80px -32px rgba(0,0,0,0.8), 0px 0px 0px 1px rgba(0,120,255,0.18)',
        padding: '28px !important',
        width: '100%',
        maxWidth: '448px !important',
        position: 'relative',
        margin: '16px',
    },
};

export const backdrop = {
    background: 'rgba(1, 1, 52, 0.72)',
    backdropFilter: 'blur(8px)',
};

export const closeButton = {
    position: 'absolute',
    top: 12,
    right: 12,
    width: 32,
    height: 32,
    padding: '8px',
    borderRadius: '8px',
    minWidth: 0,
    color: 'rgba(187, 188, 188, 1)',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
        color: '#fff',
        background: 'rgba(255,255,255,0.05)',
    },
};

export const header = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    mb: '12px',
};

export const logo = {
    width: 45,
    height: 32,
    objectFit: 'contain',
};

export const title = {
    fontSize: '18px',
    fontWeight: 600,
    color: '#fff',
    lineHeight: '28px',
};

export const description = {
    fontSize: '14px',
    fontWeight: 400,
    color: 'rgba(187,188,188,1)',
    lineHeight: '20px',
    mb: '16px',
};

export const messageBox = {
    background: 'rgba(0,0,0,0.25)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: '12px',
    padding: '12px',
    fontSize: '14px',
    color: 'rgba(255,255,255,0.90)',
    lineHeight: '20px',
    mb: '16px',
};

export const buttonsGrid = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '10px',
};

// Gradient border wrapper for each share button
export const shareButtonWrapper = {
    background: 'linear-gradient(90deg, #00D7FF, #0078FF)',
    borderRadius: '999px',
    padding: '1.5px',
    display: 'flex',
};

export const shareButton = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '44px',
    padding: '12px 17.6px',
    background: 'rgb(1, 1, 52)',
    borderRadius: '999px',
    fontSize: '14px',
    fontWeight: 600,
    color: '#fff',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'transform 0.18s ease',
    '&:hover': { transform: 'translateY(-1px)', background: 'rgb(1,1,52)' },
    '&:focus-visible': { outline: '2px solid #00D7FF', outlineOffset: '3px' },
};

export const copyButton = {
    width: '100%',
    height: '45px',
    mt: '12px',
    background: 'linear-gradient(90deg, #0078FF 0%, #00D7FF 100%)',
    borderRadius: '999px',
    fontSize: '16px',
    fontWeight: 600,
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'filter 0.2s ease',
    '&:hover': { filter: 'saturate(1.15)' },
};
